import { PersistedLocationInformation } from "@brightagency/headstart-common";
import { siteId } from "../constants";

// Returns true if running in a local dev environment
export const isLocalDev = () => window.location.href.includes(".test");

// Returns true if running on the staging site
export const isStaging = () => window.location.href.includes("dev.headstart.org.au");

// Returns true if either isStaging or isLocalDev is true
export const isDev = () => isLocalDev() || isStaging();

// Opposite of isDev
export const isProduction = () => !isDev();

export const areLocalDevFeaturesEnabled = () => isLocalDev() && false;

export const createUniqueLocalStorageKey = (key: string) => {
    return `headstart.${siteId}.${key}`;
};

export const getSuburbSelectUrl = () =>
    isLocalDev() ? "https://headstart.test/?select-region=true" : "?select-region=true";

export const getHomePageUrl = () =>
    isLocalDev() ? "https://headstart.test/?redirect=false" : "?redirect=false";

/**
 * Ensures that the url supplied by the region picker matches the current URL.
 * Use this method to determine that a user isn't visiting a region that isn't
 * serviced by their chosen suburb.
 */
export const doesSuburbMatchCurrentUrl = (suburb: PersistedLocationInformation) => {
    return window.location.href.includes(suburb.regionUrl);
};
